<template>
  <div class="box1 boxYl">
    <resize-container :tabShow="tabShow">
      <div class="grid-content bg-purple" slot="left">
        <div class="treecontent">
          <tab-tree
            @changeCompany="changeCompany"
            :data="viewTreeData"
            @tabTreeDefault="tabTreeDefault"
            @tabTreeClick="tabTreeClick"
          ></tab-tree>
        </div>
      </div>
      <div class="grid-content bg-purple">
        <div class="box bgbox">
          <div class="time_box dn-content-bg">
            <time-search
              ref="timeSearch"
              :control="{ data: timeData }"
              @timeControlClick="getSearchElem"
            >
            </time-search>
          </div>
          <div
            class="contant_box setHeight dn-content-bg"
            style="overflow:auto"
          >
            <div style="height:400px">
              <el-col :span="24" style="padding-left:0;padding-right:10px">
                <div style="height:100%">
                  <bar :barDate1="barDate1"></bar>
                </div>
              </el-col>
            </div>
            <div style="height:600px;margin-top:20px">
              <el-col :span="18" style="padding-left:0;padding-right:10px">
                <bardd :barDatedd="barDatedd"></bardd>
              </el-col>

              <el-col :span="6">
                <guan :pie="pie"></guan>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from "@/utils/index.js";
import TabTree from "@/components/common/TabTree.vue";
import Bar from "./pages/bar";
import Bardd from "./pages/bardd";
import Guan from "./pages/guan";
import * as utils from "@/utils/index.js";
import * as handleData from "@/utils/handleData.js";
import * as fpg from "@/utils/fpg.js";
import tree from "@/utils/tree.js";
import { isNull, isUndefined } from "util";
import dateTool from "@/utils/dateTool";
import TimeSearch from "@/components/common/TimeSearch.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
let allTimeData = [
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  data() {
    return {
      tabShow: true,
      timeData: allTimeData,
      viewTreeData: [],
      // checkedKeys: [],
      dataType: "0",
      barDate: {
        xdata: [],
        seriesData: [{ time: [] }, { time: [] }, { time: [] }, { time: [] }],
      }, //柱状图数据
      barDate1: {
        xdata: [],
        seriesData: [[], [], [], []],
        time: [],
        measureName: "",
        barDatedd: {},
        type: "tj",
      },
      barDatedd: {
        xdata: [],
        seriesData: [[], [], [], []],
        dateType: "",
      },
      barDatedd1: {
        xdata: [],
        seriesData: [[], [], [], []],
        dateType: "",
      },
      pie: {}, //饼图数据
      pointCode: "100229",
      pointNumber: "0",
      measureId: "", //计量点
      apiArr: [],
      fromDate: "",
      toDate: "",
      selectedDate: null,
    };
  },
  created() {},
  mounted() {},
  activated() {},
  watch: {},
  methods: {
    timeControlChange() {},
    /* 切换公司树 */
    changeCompany(companydId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companydId, "/nygl/fpgtj", null)
        .then((res) => {
          if (!res) {
            return;
          }
          vm.viewTreeData = findDataByParam("viewTree", true, res.data);
        });
    },
    /**
     * 点击查询事件
     */
    getSearchElem(elem) {
      let vm = this;
      // elem.dataType = vm.dataType;
      vm.barDatedd.dateType = elem.dateType;
      if (elem.dateType == "month") {
        vm.barDatedd.timeTitle = "1日峰平谷情况";
      }
      vm.barDate1.dateType = elem.dateType;
      vm.selectedDate = elem;
      let getNextTime = fpg.getNextTime(elem.dateType); //拿取上一时间段的值  有开始时间跟结束时间
      let str = new Date(elem.startTime);
      str.setDate(str.getDate() + 1);
      let endTime = dateTool.format(new Date(str), "yyyy-MM-dd") + " 00:00:00";
      let timeData = JSON.parse(
        JSON.stringify(
          fpg.getMatchTime(elem.startTime, elem.endTime, elem.dateType)
        )
      ); //匹配查询时间
      let currentTime = [];
      if (elem.dateType == "year") {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getCurrentMatchTime(elem.startTime, elem.endTime, elem.dateType)
          )
        ); //匹配当前时间
      } else {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getMatchTime(elem.startTime, endTime, elem.dateType)
          )
        ); //查月時拿每月第一天,查年時每年第一天
      }
      vm.barDate.seriesData[0].time = timeData;
      vm.barDate.seriesData[1].time = timeData;
      vm.barDate.seriesData[2].time = timeData;
      vm.barDate.seriesData[3].time = timeData;
      vm.barDatedd1.seriesData[0].time = currentTime;
      vm.barDatedd1.seriesData[1].time = currentTime;
      vm.barDatedd1.seriesData[2].time = currentTime;
      vm.barDatedd1.seriesData[3].time = currentTime;
      vm.barDate1.time = timeData;
      let xdata1 = handleData.default.createXData(
        elem.dateType,
        elem.startTime,
        elem.endTime
      ); //获取柱状图x轴
      let dt = "";
      if (elem.dateType == "month") {
        dt = "day";
      } else {
        dt = "month";
      }
      let xdata2 = handleData.default.createXData(dt, elem.startTime, endTime); //获取柱状图x轴
      vm.barDate1.xdata = [];
      vm.barDatedd.xdata = [];
      for (let i = 0; i < xdata1.length; i++) {
        vm.barDate1.xdata.push(xdata1[i].title);
      }
      for (let i = 0; i < xdata2.length; i++) {
        vm.barDatedd.xdata.push(xdata2[i].title);
      }
      vm.apiArr = [];
      const dateObj = {
        day: "Hour",
        week: "Day",
        month: "Day",
        year: "Month",
      };
      vm.apiArr.push(
        vm.$api.cost[`getSpentMoney${dateObj[elem.dateType]}`](
          vm.measureId,
          elem.startTime,
          elem.endTime,
          vm.pointCode,
          vm.pointNumber,
          1,
          ""
        ) //谷
      );
      if (elem.dateType == "month") {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyDay(
            vm.measureId,
            elem.startTime,
            elem.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyHour(
            vm.measureId,
            elem.startTime,
            endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      } else {
        vm.barDatedd.timeTitle = "1月峰平谷情况";
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyMonth(
            vm.measureId,
            elem.startTime,
            elem.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyDay(
            vm.measureId,
            getNextTime[0],
            getNextTime[1],
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      }
      vm.getEDate();
    },
    //type拿取饼图，柱状图的电费或电量
    getEcharts(resData, type) {
      // if()
      if (type == "pie") {
        for (let i = 0; i < resData.detail.length; i++) {
          let newDf = [];
          if (resData.detail[i].model == 1) {
            newDf.push(resData.detail[i]);
          }
          // }
          let fConsumption = null; //峰电用量
          let pConsumption = null; //平电用量
          let gConsumption = null; //谷电用量
          let eleUser = null; //累计电量
          let eleFree = null; //累计电费用
          for (let i = 0; i < newDf.length; i++) {
            if (newDf[i].values.length > 0) {
              if (!isNaN(newDf[i].values[0].energyUsed) && !fConsumption) {
                fConsumption = newDf[i].values[0].energyUsed;
              } else {
                fConsumption += newDf[i].values[0].energyUsed;
              }
              if (!isNaN(newDf[i].values[1].energyUsed) && !pConsumption) {
                pConsumption = newDf[i].values[1].energyUsed;
              } else {
                pConsumption += newDf[i].values[1].energyUsed;
              }
              if (!isNaN(newDf[i].values[2].energyUsed) && !gConsumption) {
                gConsumption = newDf[i].values[2].energyUsed;
              } else {
                gConsumption += newDf[i].values[2].energyUsed;
              }
            }
            if (!isNaN(newDf[i].energyUsed) && !eleUser) {
              eleUser = newDf[0].energyUsed;
            } else {
              eleUser += newDf[i].energyUsed;
            }
            if (!isNaN(newDf[i].value) && !eleFree) {
              eleFree = newDf[0].value;
            } else {
              eleFree += newDf[i].value;
            }
          }
          fConsumption = isNull(fConsumption) ? "-" : fConsumption.toFixed(2); //峰电量
          pConsumption = isNull(pConsumption) ? "-" : pConsumption.toFixed(2); //平电量
          gConsumption = isNull(gConsumption) ? "-" : gConsumption.toFixed(2); //谷电量
          eleUser = isNull(eleUser) ? "-" : eleUser.toFixed(2); //用量
          eleFree = isNull(eleFree) ? "-" : eleFree.toFixed(2); //費用
          resData.fValue = fConsumption;
          resData.pValue = pConsumption;
          resData.gValue = gConsumption;
          resData.userValue = eleUser;
          resData.eleValue = eleFree;
        }
      } else {
        for (let k = 0; k < resData.length; k++) {
          //拿当前月的用电量
          let newDf = [];
          for (let i = 0; i < resData[k].detail.length; i++) {
            if (resData[k].detail[i].model == 1) {
              newDf.push(resData[k].detail[i]);
            }
          }
          let fConsumption = null; //峰电用量
          let pConsumption = null; //平电用量
          let gConsumption = null; //谷电用量
          let eleUser = null; //累计电量
          let eleFree = null; //累计电费用
          for (let i = 0; i < newDf.length; i++) {
            if (newDf[i].values.length > 0) {
              if (!isNaN(newDf[i].values[0].energyUsed) && !fConsumption) {
                fConsumption = newDf[i].values[0].energyUsed;
              } else {
                fConsumption += newDf[i].values[0].energyUsed;
              }
              if (!isNaN(newDf[i].values[1].energyUsed) && !pConsumption) {
                pConsumption = newDf[i].values[1].energyUsed;
              } else {
                pConsumption += newDf[i].values[1].energyUsed;
              }
              if (!isNaN(newDf[i].values[2].energyUsed) && !gConsumption) {
                gConsumption = newDf[i].values[2].energyUsed;
              } else {
                gConsumption += newDf[i].values[2].energyUsed;
              }
            }
            if (!isNaN(newDf[i].energyUsed) && !eleUser) {
              eleUser = newDf[0].energyUsed;
            } else {
              eleUser += newDf[i].energyUsed;
            }
            if (!isNaN(newDf[i].value) && !eleFree) {
              eleFree = newDf[0].value;
            } else {
              eleFree += newDf[i].value;
            }
          }
          fConsumption = isNull(fConsumption) ? "-" : fConsumption.toFixed(2); //峰电量
          pConsumption = isNull(pConsumption) ? "-" : pConsumption.toFixed(2); //平电量
          gConsumption = isNull(gConsumption) ? "-" : gConsumption.toFixed(2); //谷电量
          eleUser = isNull(eleUser) ? "-" : eleUser.toFixed(2); //用量
          eleFree = isNull(eleFree) ? "-" : eleFree.toFixed(2); //費用
          resData[k].fValue = fConsumption;
          resData[k].pValue = pConsumption;
          resData[k].gValue = gConsumption;
          resData[k].userValue = eleUser;
          resData[k].eleValue = eleFree;
        }
      }
    },
    //获取数据
    getEDate() {
      let vm = this;
      Promise.all(vm.apiArr).then((res) => {
        let barDate1 = JSON.parse(JSON.stringify(vm.barDate1));
        let barDatedd = JSON.parse(JSON.stringify(vm.barDatedd));
        res[0].data = {detail: res[0].data.map(k => k.detail[0])}
        fpg.getEcharts(res[0].data, "pie"); //拿取当前饼图用电量
        vm.pie = {
          yester: [
            {
              value: res[0].data.fValue == "-" ? 0 : res[0].data.fValue,
              name: "峰期用电量",
            },
            {
              value: res[0].data.pValue == "-" ? 0 : res[0].data.pValue,
              name: "平期用电量",
            },
            {
              value: res[0].data.gValue == "-" ? 0 : res[0].data.gValue,
              name: "谷期用电量",
            },
          ],
          dateType: vm.selectedDate.dateType,
        };
        let searchRes = []; //查询时间接口数据
        let searchCurrentRes = []; //当前时间接口
        if (vm.selectedDate.dateType == "month") {
          searchRes = res[1].data[0];
          searchCurrentRes = res[2].data;
        } else {
          searchRes = res[1].data;
          searchCurrentRes = res[2].data[0];
        }
        fpg.getEcharts(searchRes, "bar"); //当前时间段的柱状图，
        fpg.getEcharts(searchCurrentRes, "bar"); //上一时间段的柱状图
        vm.barDate.seriesData[0].time = fpg.timeChabge1(
          vm.barDate.seriesData[0].time,
          searchRes,
          "f"
        ); //转换峰数据  拿当前月的
        vm.barDate.seriesData[1].time = fpg.timeChabge1(
          vm.barDate.seriesData[1].time,
          searchRes,
          "p"
        ); //转换平数据
        vm.barDate.seriesData[2].time = fpg.timeChabge1(
          vm.barDate.seriesData[2].time,
          searchRes,
          "g"
        ); //转换谷数据
        vm.barDate.seriesData[3].time = fpg.timeChabge1(
          vm.barDate.seriesData[3].time,
          searchRes,
          "total"
        ); //转换谷数据
        vm.barDatedd1.seriesData[0].time = fpg.timeChabge1(
          vm.barDatedd1.seriesData[0].time,
          searchCurrentRes,
          "f"
        ); //转换峰数据  //拿当前日的
        vm.barDatedd1.seriesData[1].time = fpg.timeChabge1(
          vm.barDatedd1.seriesData[1].time,
          searchCurrentRes,
          "p"
        ); //转换平数据
        vm.barDatedd1.seriesData[2].time = fpg.timeChabge1(
          vm.barDatedd1.seriesData[2].time,
          searchCurrentRes,
          "g"
        ); //转换谷数据
        vm.barDatedd1.seriesData[3].time = fpg.timeChabge1(
          vm.barDatedd1.seriesData[3].time,
          searchCurrentRes,
          "total"
        ); //转换谷数据
        barDate1.seriesData = [[], [], [], []];
        barDatedd.seriesData = [[], [], [], []];
        for (let i = 0; i < vm.barDate.seriesData.length; i++) {
          for (let j = 0; j < vm.barDate.seriesData[i].time.length - 1; j++) {
            barDate1.seriesData[i].push(vm.barDate.seriesData[i].time[j].value);
          }
        }
        for (let i = 0; i < vm.barDatedd1.seriesData.length; i++) {
          for (
            let j = 0;
            j < vm.barDatedd1.seriesData[i].time.length - 1;
            j++
          ) {
            barDatedd.seriesData[i].push(
              vm.barDatedd1.seriesData[i].time[j].value
            );
          }
        }
        //  删除曲线
        barDatedd.seriesData.splice(barDatedd.seriesData.length - 1, 1);
        vm.barDatedd = barDatedd;
        barDate1.barDatedd = vm.barDatedd;
        barDate1.barDatedd1 = vm.barDatedd1;
        vm.barDate1 = JSON.parse(JSON.stringify(barDate1));
      });
    },
    //树加载
    tabTreeDefault(node) {
      let vm = this;
      vm.measureId = node.measureId;
      vm.barDate1.measureId = node.measureId;
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-") + "01 00:00:00";
      time.setMonth(time.getMonth() + 1);
      let endTime = dateTool.format(new Date(time), "yyyy-MM-") + "01 00:00:00";
      vm.selectedDate = {
        dataType: "1",
        dateType: "month",
        endTime: endTime,
        startTime: startTime,
      };
      vm.getSearchElem(vm.selectedDate);
    },
    tabTreeClick(e) {
      this.measureId = e.measureId;
      this.barDate1.measureId = e.measureId;
      this.getSearchElem(this.selectedDate);
    },
  },
  components: { TimeSearch, Bar, Guan, Bardd, TabTree, ResizeContainer },
};
</script>
<style lang="scss">
.boxYl {
  .el-table th,
  .el-table tr {
    background-color: #fff;
    height: 50px;
  }
}
</style>
<style lang="scss" scoped>
.box1 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 14px;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  //   background: #99a9bf;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  //   background: #f5f5f5;
  box-sizing: border-box;
}

.bgbox {
  position: relative;
  padding-top: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-flow: column;
}
.time_box {
  width: 100%;
  padding: 5px 0;
}
.contant_box {
  padding: 14px;
  padding-bottom: 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
  display: flex;
  flex: 1;
  flex-flow: column;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
.box .barTop {
  height: 49%;
}
.box .barTopleft[data-v-42e46192] {
  padding-left: 0;
  padding-right: 10px;
}
.box .barTopright[data-v-42e46192] {
  padding-left: 10px;
  padding-right: 0;
}
.box .barbottom {
  height: 49%;
  margin-top: 20px;
}
</style>
